import Alert from "@/components/alert/Alert";
import ToggleInput from "@/components/toggle/Toggle";
import ScheduleSelectTime from "@/components/selectTime/ScheduleSelectTime";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { formStateChange } from "@/redux/slices/formSlice";
import ChangesAlert from "@/components/alert/ChangesAlert";
import { Button } from "@thdinc/hpf-shared";

interface Schedule {
  start: string;
  end: string;
  active: boolean;
  isNew: boolean;
}

interface BartenderSchedule {
  sun: Schedule;
  mon: Schedule;
  tue: Schedule;
  wed: Schedule;
  thu: Schedule;
  fri: Schedule;
  sat: Schedule;
}

interface Props {
  bartenderSchedule: BartenderSchedule;
  updateScheduleFun: (schedule: BartenderSchedule) => void;
  active: boolean;
  updateActive: (status: boolean) => void;
}

const BartenderScheduleForm: React.FC<Props> = ({
  bartenderSchedule,
  updateScheduleFun,
  active,
  updateActive,
}) => {
  const [scheduleState, setScheduleState] =
    useState<BartenderSchedule>(bartenderSchedule);
  const [changed, setChanged] = useState<boolean>(false);
  const [modal, setModal] = useState<boolean>(false);
  const [modal2, setModal2] = useState<boolean>(false);

  const dispatch = useDispatch();

  // changing the time
  const handleTimeChange = (
    day: keyof BartenderSchedule,
    field: keyof Schedule,
    value: string
  ) => {
    // function to update the schedule state with the new value

    setScheduleState((prevSchedule) => {
      const updatedSchedule = {
        ...prevSchedule,
        [day]: {
          ...prevSchedule[day],
          [field]: value,
        },
      };

      // Ensure end time is greater than start time
      // if (field === "end" && updatedSchedule[day].start > value) {
      //   Alert({ message: "End time must be greater than start time", type: "error" })
      //   setChanged(false)
      //   dispatch(formStateChange(false))
      //   return prevSchedule;
      // }
      // // Ensure start time is less than end time
      // if (field === "start" && updatedSchedule[day].end < value) {
      //   Alert({ message: "Start time must be less than end time", type: "error" })
      //   setChanged(false)
      //   dispatch(formStateChange(false))
      //   return prevSchedule;
      // }
      setChanged(true);
      dispatch(formStateChange(true));
      return updatedSchedule;
    });
  };

  const handleToggleChange = (
    day: keyof BartenderSchedule,
    status: boolean
  ) => {
    // function to update the schedule active state
    setScheduleState((prevSchedule) => {
      const updatedSchedule = {
        ...prevSchedule,
        [day]: {
          ...prevSchedule[day],
          active: status,
          start:
            prevSchedule[day].start == "00:00"
              ? "09:00"
              : prevSchedule[day].start,
          end:
            prevSchedule[day].end == "00:00" ? "18:00" : prevSchedule[day].end,
        },
      };

      // Ensure end time is greater than start time
      setChanged(true);
      dispatch(formStateChange(true));
      return updatedSchedule;
    });
  };

  const saveSchedule = () => {
    dispatch(formStateChange(false));
    setChanged(false);
    // sending to parent comp
    updateScheduleFun(scheduleState);
    setModal(false);
  };
  useEffect(() => {
    setScheduleState(bartenderSchedule);
  }, [bartenderSchedule]);

  // const toggleOff = ()=>{
  //   if (active) {

  //     setModal2(true)
  //   } else {
  //     Alert({ message: "Please enable and select time first!", type: "error" })
  //   }
  // }

  return (
    <div className="  bg-white rounded-2xl p-6 ">
      <div className=" md:flex-row justify-between items-start  ">
        <div className="mb-4">
          <div className="flex justify-between items-center ">
            <p className="text-2xl font-semibold ">Weekly Availability</p>
            <div className="flex items-center ">
              {/* <p className="text-gray-700 mr-4 font-semibold">Active</p> */}
              <ToggleInput
                onChange={() => {
                  if (active) {
                    // updateActive(!active)
                    setModal2(true);
                  } else {
                    Alert({
                      message: "Please enable and select time first!",
                      type: "error",
                    });
                  }
                }}
                checked={active}
              />
            </div>
          </div>
          <p className="text-gray-700 mt-2 mr-2">
            Use this to set the typical weekly schedule of each bartender.
          </p>
        </div>
        <div className="flex flex-col gap-2">
          {/* Monday */}
          <div>
            <div className="flex gap-2 items-center my-2   justify-between">
              <span className="font-semibold sm:mr-4   sm:text-base  ">
                Mondays{" "}
              </span>
              <ToggleInput
                onChange={() =>
                  handleToggleChange("mon", !scheduleState?.mon?.active)
                }
                checked={scheduleState?.mon?.active}
              />
            </div>
            <div className=" flex md:flex-row flex-col justify-between gap-3 items-center">
              <ScheduleSelectTime
                disabled={!scheduleState?.mon?.active}
                value={scheduleState?.mon?.start}
                sliceValue={scheduleState?.mon?.end}
                day="mon" // Specify the day
                field="start" // Specify the field
                onChange={handleTimeChange} // Pass the handleTimeChange function directly
              />
              <span className="text-primary-red">To</span>
              <ScheduleSelectTime
                disabled={!scheduleState?.mon?.active}
                value={scheduleState?.mon?.end}
                sliceValue={scheduleState?.mon?.start}
                day="mon" // Specify the day
                field="end" // Specify the field
                onChange={handleTimeChange} // Pass the handleTimeChange function directly
              />
            </div>
          </div>
          {/* Tue */}
          <div>
            <div className="flex gap-2 items-center my-2   justify-between">
              <span className="font-semibold sm:mr-4   sm:text-base  ">
                Tuesdays{" "}
              </span>
              <ToggleInput
                onChange={() =>
                  handleToggleChange("tue", !scheduleState?.tue?.active)
                }
                checked={scheduleState?.tue?.active}
              />
            </div>
            <div className="flex  md:flex-row flex-col justify-between gap-3 items-center">
              <ScheduleSelectTime
                disabled={!scheduleState?.tue?.active}
                value={scheduleState?.tue?.start}
                sliceValue={scheduleState?.tue?.end}
                day="tue" // Specify the day
                field="start" // Specify the field
                onChange={handleTimeChange} // Pass the handleTimeChange function directly
              />
              <span className="text-primary-red">To</span>
              <ScheduleSelectTime
                disabled={!scheduleState?.tue?.active}
                sliceValue={scheduleState?.tue?.start}
                value={scheduleState?.tue?.end}
                day="tue" // Specify the day
                field="end" // Specify the field
                onChange={handleTimeChange} // Pass the handleTimeChange function directly
              />
            </div>
          </div>
          {/* Wed */}
          <div>
            <div className="flex gap-2 items-center my-2   justify-between">
              <span className="font-semibold sm:mr-4   sm:text-base  ">
                Wednesdays
              </span>
              <ToggleInput
                onChange={() =>
                  handleToggleChange("wed", !scheduleState?.wed?.active)
                }
                checked={scheduleState?.wed?.active}
              />
            </div>
            <div className="flex  md:flex-row flex-col justify-between gap-3 items-center">
              <ScheduleSelectTime
                disabled={!scheduleState?.wed?.active}
                value={scheduleState?.wed?.start}
                sliceValue={scheduleState?.wed?.end}
                day="wed" // Specify the day
                field="start" // Specify the field
                onChange={handleTimeChange} // Pass the handleTimeChange function directly
              />
              <span className="text-primary-red">To</span>
              <ScheduleSelectTime
                disabled={!scheduleState?.wed?.active}
                value={scheduleState?.wed?.end}
                sliceValue={scheduleState?.wed?.start}
                day="wed" // Specify the day
                field="end" // Specify the field
                onChange={handleTimeChange} // Pass the handleTimeChange function directly
              />
            </div>
          </div>
          {/* Thur */}
          <div>
            <div className="flex gap-2 items-center my-2   justify-between">
              <span className="font-semibold sm:mr-4   sm:text-base">
                Thursdays{" "}
              </span>
              <div className="">
                <ToggleInput
                  onChange={() =>
                    handleToggleChange("thu", !scheduleState?.thu?.active)
                  }
                  checked={scheduleState?.thu?.active}
                />
              </div>
            </div>
            <div className="flex   md:flex-row flex-col justify-between gap-3 items-center">
              <ScheduleSelectTime
                disabled={!scheduleState?.thu?.active}
                value={scheduleState?.thu?.start}
                sliceValue={scheduleState?.thu?.end}
                day="thu" // Specify the day
                field="start" // Specify the field
                onChange={handleTimeChange} // Pass the handleTimeChange function directly
              />
              <span className="text-primary-red">To</span>
              <ScheduleSelectTime
                disabled={!scheduleState?.thu?.active}
                sliceValue={scheduleState?.thu?.start}
                value={scheduleState?.thu?.end}
                day="thu" // Specify the day
                field="end" // Specify the field
                onChange={handleTimeChange} // Pass the handleTimeChange function directly
              />
            </div>
          </div>
          {/* Fri */}
          <div>
            <div className="flex gap-2 items-center my-2   justify-between">
              <span className="font-semibold sm:mr-4   sm:text-base">
                Fridays{" "}
              </span>
              <ToggleInput
                onChange={() =>
                  handleToggleChange("fri", !scheduleState?.fri?.active)
                }
                checked={scheduleState?.fri?.active}
              />
            </div>
            <div className="flex   md:flex-row flex-col justify-between gap-3 items-center">
              <ScheduleSelectTime
                disabled={!scheduleState?.fri?.active}
                value={scheduleState?.fri?.start}
                sliceValue={scheduleState?.fri?.end}
                day="fri" // Specify the day
                field="start" // Specify the field
                onChange={handleTimeChange} // Pass the handleTimeChange function directly
              />
              <span className="text-primary-red">To</span>
              <ScheduleSelectTime
                disabled={!scheduleState?.fri?.active}
                value={scheduleState?.fri?.end}
                sliceValue={scheduleState?.fri?.start}
                day="fri" // Specify the day
                field="end" // Specify the field
                onChange={handleTimeChange} // Pass the handleTimeChange function directly
              />
            </div>
          </div>
          {/* Sat */}
          <div>
            <div className="flex gap-2 items-center my-2   justify-between">
              <span className="font-semibold sm:mr-4   sm:text-base">
                Saturdays{" "}
              </span>
              <ToggleInput
                onChange={() =>
                  handleToggleChange("sat", !scheduleState?.sat?.active)
                }
                checked={scheduleState?.sat?.active}
              />
            </div>
            <div className="flex  md:flex-row flex-col justify-between gap-3 items-center">
              <ScheduleSelectTime
                disabled={!scheduleState?.sat?.active}
                value={scheduleState?.sat?.start}
                sliceValue={scheduleState?.sat?.end}
                day="sat" // Specify the day
                field="start" // Specify the field
                onChange={handleTimeChange} // Pass the handleTimeChange function directly
              />
              <span className="text-primary-red">To</span>
              <ScheduleSelectTime
                disabled={!scheduleState?.sat?.active}
                value={scheduleState?.sat?.end}
                sliceValue={scheduleState?.sat?.start}
                day="sat" // Specify the day
                field="end" // Specify the field
                onChange={handleTimeChange} // Pass the handleTimeChange function directly
              />
            </div>
          </div>
          {/* Sun */}
          <div>
            <div className="flex gap-2 items-center my-2   justify-between">
              <span className="font-semibold sm:mr-4   sm:text-base">
                Sundays{" "}
              </span>
              <ToggleInput
                onChange={() =>
                  handleToggleChange("sun", !scheduleState?.sun?.active)
                }
                checked={scheduleState?.sun?.active}
              />
            </div>
            <div className="flex  md:flex-row flex-col justify-between gap-3 items-center">
              <ScheduleSelectTime
                disabled={!scheduleState?.sun?.active}
                value={scheduleState?.sun?.start}
                sliceValue={scheduleState?.sun?.end}
                day="sun" // Specify the day
                field="start" // Specify the field
                onChange={handleTimeChange} // Pass the handleTimeChange function directly
              />
              <span className="text-primary-red">To</span>
              <ScheduleSelectTime
                disabled={!scheduleState?.sun?.active}
                value={scheduleState?.sun?.end}
                sliceValue={scheduleState?.sun?.start}
                day="sun" // Specify the day
                field="end" // Specify the field
                onChange={handleTimeChange} // Pass the handleTimeChange function directly
              />
            </div>
          </div>
          <div className="flex justify-end">
            <div></div>
            <Button
              classes={`
                ${
                  changed
                    ? "bg-primary-red text-white hover:bg-primary-red-button-hover "
                    : "bg-gray-300   text-gray-500 "
                } mt-3  `}
              // disabled={!changed}
              onClick={() => {
                setModal(true);
              }}
            >
              Save
            </Button>
          </div>
        </div>
      </div>
      <ChangesAlert
        title={"Save Changes"}
        desc={`Are you sure you want to save this changes?`}
        positiveButtonText={"Yes"}
        negativeButtonText={"Cancel"}
        handleDiscardChanges={() => {
          setModal(false);
        }}
        handleSaveChanges={saveSchedule}
        isOpen={modal}
      />
      <ChangesAlert
        title={"Save Changes"}
        desc={`Are you sure you want to save this changes?`}
        positiveButtonText={"Yes"}
        negativeButtonText={"Cancel"}
        handleDiscardChanges={() => {
          setModal2(false);
        }}
        handleSaveChanges={() => {
          const fun = updateActive(!active);
          setModal2(false);
          return fun;
        }}
        isOpen={modal2}
      />
    </div>
  );
};

export default BartenderScheduleForm;
